import { LanguageIcon } from './types';

export const Empty: LanguageIcon = () => (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="22" height="22" fill="gray" />
    </svg>
);
